import React, { useCallback, useEffect } from 'react';
import styled from "@emotion/styled";
import sliderIcon from '../../assets/sliderCube.png'

export const range: any = {
    0.5: [-500, 0, 17, 0],
    0.75: [-167, 17, 33, 25],
    1: [0, 33, 56.25, 50],
    1.25: [200, 56.25, 68.75, 62.5],
    1.5: [333, 68.75, 81.25, 75],
    1.75: [429, 81.25, 93.75, 87.5],
    2: [500, 93.75, 100, 100],
}

const MySlider = ({ change, type, initVal, state, sliderWidth }: { change: (param: any) => void, type: string, initVal: any, state?: any, sliderWidth: number }) => {
    const init = useCallback(() => {
        //  获取所有的节点元素
        const bar: any = document.getElementById(`bar-${type}`)
        const progress: any = document.getElementById(`progress-${type}`)
        const dot: any = document.getElementById(`dot-${type}`)
        const num: any = document.getElementById(`num-${type}`)
        if (sliderWidth === 394) {
            progress.style.width = bar.offsetWidth / 2.8 + 'px';
        } else {
            progress.style.width = bar.offsetWidth / 2 + 'px';
        }

        dot.style.left = progress.style.width.slice(0, -2) - dot.offsetWidth / 2 + 'px';

        /*
        * offsetWidth 获取当前节点的宽度 （width + border + padding）
        **/
        // 总长度减去原点覆盖的部分
        const rest = bar.offsetWidth - dot.offsetWidth / 2;

        // 鼠标按下事件
        dot.onmousedown = function (ev: any) {
            /*
            * offsetLeft 获取的是相对于父对象的左边距, 返回的是数值， 没有单位
            */
            let dotL = dot.offsetLeft
            let e = ev || window.event //兼容性
            /*
            * clientX 事件属性返回当事件被触发时鼠标指针向对于浏览器页面（或客户区）的水平坐标。
            */
            let mouseX = e.clientX //鼠标按下的位置
            let widths = sliderWidth
            window.onmousemove = function (ev) {
                let e = ev || window.event
                // 浏览器当前位置减去鼠标按下的位置
                let moveL = e.clientX - mouseX //鼠标移动的距离

                // 保存newL是必要的
                let newL = dotL + moveL //left值
                // 判断最大值和最小值
                if (newL < 0) {
                    newL = 0
                }
                if (newL >= rest) {
                    newL = rest
                }
                dot.style.left = newL + 'px'

                // 计算比例
                let bili;
                let progressWidth;
                let displayValue;

                if (sliderWidth === 394) {
                    bili = newL / rest * 14;
                    // 距离左侧距离
                    progressWidth = widths * Math.ceil(bili) / 14 + 'px';
                    displayValue = Math.ceil(bili) + 1 + 's';
                    dot.style.left = Math.max(0, progress.style.width.slice(0, -2) - dot.offsetWidth / 2) + 'px'
                } else {
                    bili = newL / rest * 100;
                    progressWidth = widths * Math.ceil(bili) / 100 + 'px';
                    displayValue = Math.ceil(bili);
                }

                if (['vol', 'vols', 'textDuration', 'conversionDuration', 'continuationDuration'].includes(type)) {
                    num.innerHTML = displayValue;
                }

                progress.style.width = progressWidth;

                if (!['vol', 'vols', 'textDuration', 'conversionDuration', 'continuationDuration'].includes(type)) {
                    const scale = parseFloat(progressWidth) / bar.offsetWidth * 100;
                    JudgeSpeed(scale);
                }

                change(num.innerHTML);

                return false //取消默认事件
            }
            window.onmouseup = function () {
                // @ts-ignore
                window.onmousemove = () => false //解绑移动事件
                return false
            }

            return false
        };

        // bar.onclick = function (ev: any) {
        //         let left = ev.clientX - content.offsetLeft - dot.offsetWidth / 2;
        //         if (left < 0) {
        //             left = 0
        //         }
        //         if (left >= rest) {
        //             left = rest
        //         }
        //         dot.style.left = left + 'px'
        //         const bili = left / rest * 100
        //         if (type === 'vol'){
        //             num.innerHTML = Math.ceil(bili) + '%'
        //             progress.style.width = 394 * Math.ceil(bili) / 100 + 'px';
        //         } else {
        //             JudgeSpeed(bili)
        //         }
        //
        //     return false
        // }
        const JudgeSpeed = (scale: number) => {
            let widths = sliderWidth
            for (let rangeKey in range) {
                if (scale > range[rangeKey][1] && scale < range[rangeKey][2]) {
                    num.innerHTML = rangeKey + '×';
                    progress.style.width = widths * range[rangeKey][3] / 100 + 'px';
                    dot.style.left = Math.max(0, progress.style.width.slice(0, -2) - dot.offsetWidth / 2) + 'px';
                }
            }
        }
    }, []);

    useEffect(() => {
        init();
    }, []);

    const getValueByType = (type) => {
        switch (type) {
            case 'vol':
                return "50";
            case 'textDuration':
            case 'conversionDuration':
            case 'continuationDuration':
                return '6s';
            case 'vols':
                return "50";
            default:
                return '1x';
        }
    };

    return (
        <>
            {
                state === 'compound' ? <Frame >
                    <Content style={{ width: sliderWidth }} id={`content-${type}`}>
                        <Bar style={{ width: sliderWidth }} id={`bar-${type}`}>
                            <Progress id={`progress-${type}`} />
                            <Dot id={`dot-${type}`} />
                        </Bar>
                        <Number style={{ right: '-55px' }} id={`num-${type}`}>
                            {
                                getValueByType(type)
                            }
                        </Number>
                    </Content>
                </Frame> : <Frame style={{ width: 249 }} >
                    <Content style={{ width: 249 }} id={`content-${type}`}>
                        <Bar style={{ width: 179, position: 'absolute', left: '-34px' }} id={`bar-${type}`}>
                            <Progress id={`progress-${type}`} />
                            <Dot id={`dot-${type}`} />
                        </Bar>
                        <Number style={{ position: 'absolute', right: '15px' }} id={`num-${type}`}>
                            {
                                type === 'vols' ? "50" : "1×"
                            }
                        </Number>
                    </Content>
                </Frame>
            }
        </>
    );
}

export default MySlider;


const Frame = styled.div`
  /* width: 100%; */
  height: 50px;
  background: #F6F6F6;
  position: relative;
  margin-top: 12px;
`

const Content = styled.div`
  height: 50px;
  position: relative;

`

const Bar = styled.div`
  height: 8px;
  border-radius: 10px;
  background: #ffffff;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 20px;
  right: 0;
  margin: auto;
  cursor: pointer;
`

const Progress = styled.div`
  width: 0;
  height: 8px;
  border-radius: 8px;
  background: #FF671D;
`

const Dot = styled.div`
  width: 30px;
  height: 20px;
  background: url(${sliderIcon}) no-repeat;
  box-shadow: 0 4px 10px 0 rgba(255,103,29,0.2);;
  position: absolute;
  bottom: 0;
  top: 0;
  margin: auto 0;
  cursor: pointer;
`

const Number = styled.span`
  color: #222222;
  text-align: right;
  line-height: 14px;
  font-weight: 400;
  position: absolute;
  right: -78px;
  bottom: 18px;
  font-size: 14px;
  font-weight: normal;
`
